import {
  ADD_PRODUCT_FAILED,
  ADD_PRODUCT_SUCCESS,
  RESET_ADD_PRODUCT,
  LOADING_ADD_PRODUCT,
  ADD_PRODUCT_INVALID_REQUEST,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADD_PRODUCT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        status: "",
      };

    case ADD_PRODUCT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        status: "Add to cart failed!",
      };
    case ADD_PRODUCT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        status: "Oops, Something went wrong!",
      };

    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        status: "Product added to the cart!",
      };

    case RESET_ADD_PRODUCT:
      return (state = initialState);

    default:
      return state;
  }
};
